import { render } from "./LeLogo.vue?vue&type=template&id=f04dc2a8&scoped=true"
import script from "./LeLogo.vue?vue&type=script&lang=js"
export * from "./LeLogo.vue?vue&type=script&lang=js"

import "./LeLogo.vue?vue&type=style&index=0&id=f04dc2a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04dc2a8"]])

export default __exports__